import { Store } from '@/Core/Models/Stores'
import * as _ from 'lodash-es'
import { Component, MapAction, Vue } from 'types-vue'

@Component
export default class FiltersContainer extends Vue {

  @MapAction(Store.ReportsHistorical)
  protected newTypeFilterValue: (newValues: 'USERNAME' | 'MARKETER') => any

}
